module.exports = __webpack_public_path__ + "static/img/finished-game.03c88c97.png";